import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  SAVE_START,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  VIEW_START,
  VIEW_SUCCESS,
  VIEW_FAILURE,
  REQUEST_START,
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  LOAD_CATEGORIES_START,
  LOAD_CATEGORIES_SUCCESS,
  LOAD_CATEGORIES_FAILURE
} from './actions';

const initialState = {
  loading: false,
  loadingCategories: false,
  asks: [],
  ask: null,
  saving: false,
  requesting: false,
  paging: false,
  categories: [],
  pagination: {},
  defaultTerms: ''
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);

  let askId;

  switch (action.type) {
    case LOAD_START:
      newState.paging = false;
      if (action.payload.paging) {
        newState.paging = true;
      } else {
        newState.loading = true;
      }
      newState.ask = null;
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.asks = action.payload.data;
      newState.paging = false;
      /*
      if (action.payload.append) {
        newState.asks = newState.asks.concat(action.payload.data);
      } else {
        newState.asks = action.payload.data;
      }
      */
      newState.categories = action.payload.categories;
      newState.pagination = action.payload.pagination;
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      newState.paging = false;
      break;
    case SAVE_START:
      askId = action.payload;
      if (newState.ask && newState.ask.id === askId) {
        newState.saving = true;
      } else {
        if (newState.asks.length > 0) {
          newState.asks = newState.asks.map(ask => {
            if (ask.id === askId) {
              ask.saving = true;
            }
            return ask;
          });
        }
      }
      break;
    case SAVE_SUCCESS:
      askId = action.payload;
      if (newState.ask && newState.ask.id === askId) {
        newState.saving = false;
        newState.ask.saved = !newState.ask.saved;
      } else {
        if (newState.asks.length > 0) {
          newState.asks = newState.asks.map(ask => {
            if (ask.id === askId) {
              ask.saving = false;
              ask.saved = !ask.saved;
            }
            return ask;
          });
        }
      }
      break;
    case SAVE_FAILURE:
      askId = action.payload;
      if (newState.ask && newState.ask.id === askId) {
        newState.saving = false;
      } else {
        if (newState.asks.length > 0) {
          newState.asks = newState.asks.map(ask => {
            if (ask.id === askId) {
              ask.saving = false;
            }
            return ask;
          });
        }
      }
      break;
    case VIEW_START:
      newState.loading = true;
      newState.ask = null;
      break;
    case VIEW_SUCCESS:
      newState.loading = false;
      newState.ask = action.payload.ask;
      newState.defaultTerms = action.payload.terms;
      newState.ask.saving = false;
      break;
    case VIEW_FAILURE:
      newState.loading = false;
      newState.ask = null;
      break;
    case REQUEST_START:
      newState.requesting = true;
      break;
    case REQUEST_SUCCESS:
      newState.requesting = false;
      newState.ask.corporate_partnership = action.payload;
      break;
    case REQUEST_FAILURE:
      newState.requesting = false;
      break;
    case LOAD_CATEGORIES_START:
      newState.loadingCategories = true;
      break;
    case LOAD_CATEGORIES_SUCCESS:
      newState.loadingCategories = false;
      newState.categories = action.payload;
      break;
    case LOAD_CATEGORIES_FAILURE:
      newState.loadingCategories = false;
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/browse/reducer.js